import axios from "axios";
import { checkStatus, parseJSON } from './responseHandler'
import { BASE_API_URL } from '../utils/constant'
import Vue from 'vue'
import VueCookie from 'vue-cookie'


Vue.use(VueCookie);

// Make an api call

export default async (url, method = 'post', body) => {
	// headers
	let headers = {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*'
	}

	if (url !== '/celebrity/login') {
		headers['celeb-id'] = JSON.parse(VueCookie.get("user")).celebrity_id
	}

	return axios(`${BASE_API_URL}${url}`, {
		method,
		data: JSON.stringify(body),
		headers
	})
		.then(checkStatus)
		.then(parseJSON)
		.catch(error => {
			throw error
		})
}
